// extracted by mini-css-extract-plugin
export default {"shares-per-network":"shares-per-network__BB7bL","shares-per-network-item":"shares-per-network-item__JxdOa","shares-per-network-item-value":"shares-per-network-item-value__hCyDk"};